define('GoogleTagManager.Ext', [
  'GoogleTagManager',
  'underscore',
  'Tracker',
  'Backbone',
  'GTMExtension.Main.Model'
],	function (
  GoogleTagManager,
  _,
  Tracker,
  Backbone,
  GTMExtensionModel
) {
  'use strict';

  return {

    loadModule: function loadModule() {

      _.extend(GoogleTagManager, {

        // this gets data from backend
        fetchGTMContact: function () {
          var gtmExtModel = new GTMExtensionModel();
          var gtmExtModelPormise = gtmExtModel.fetch({
            async: false
          });
          return gtmExtModelPormise;
        },
        // this gets data locally
        getGTMContact: function () {
          var self = this;

          if(self.getCookie('uifl') && self.getCookie('uifl').length > 0) {
            var strUserInfo = self.getCookie('uifl');
            self.setCookie('uifl', strUserInfo, 15);
            strUserInfo = self.decodeData(strUserInfo);
            return strUserInfo;
          }
          return false;
        },

        encodeData: function (objJson) {
          var objStr = btoa(JSON.stringify(objJson));
          return objStr;
        },

        decodeData: function (objStr) {
          var objJson = atob(objStr);
          return JSON.parse(objJson);
        },

        getCookie: function getCookie(name) {
          var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
          return v ? v[2] : null;
        },

        setCookie: function setCookie(name, value, minutes) {
          var d = new Date();
          d.setTime(d.getTime() + 60 * 1000 * minutes);
          document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
        },

        trackPageview: function (url) {
          var self = this;

          if (_.isString(url)) {
            var eventName = 'pageView';
            var eventData = {
              event: eventName,
              data: {
                page: url
              }
            };
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace
            // data before is send it to Google Tag Manager

            var tisUserInfo = self.getGTMContact();
            if(tisUserInfo) {
              // console.log('local', tisUserInfo);
              /* eslint-disable */
              eventData.data.user_id = tisUserInfo.contact_id;
              eventData.data.contact_id = tisUserInfo.contact_id;
              eventData.data.customer_id = tisUserInfo.customer_id;
              eventData.user_id = tisUserInfo.contact_id;
              eventData.contact_id = tisUserInfo.contact_id;
              eventData.customer_id = tisUserInfo.customer_id;
			  
              Tracker.trigger(eventName, eventData, url);
              this.pushData(eventData);
            } else {
              self.fetchGTMContact().done(function (result) {
                tisUserInfo = result;
                self.setCookie('uifl', self.encodeData(result), 15);
                // console.log('fetch', result);
                eventData.data.user_id = tisUserInfo.contact_id;
                eventData.data.contact_id = tisUserInfo.contact_id;
                eventData.data.customer_id = tisUserInfo.customer_id;
                eventData.user_id = tisUserInfo.contact_id;
                eventData.contact_id = tisUserInfo.contact_id;
                eventData.customer_id = tisUserInfo.customer_id;
				/* eslint-enable */
                Tracker.trigger(eventName, eventData, url);
                this.pushData(eventData);
              });
            }
            // console.log('trackPageview', eventData);
          }
          return this;
        },

        trackHomePageview: function (url) {
          if (_.isString(url)) {
            var eventName = 'homeView';
            var eventData = {
              event: eventName,
              data: {
                page: url
              }
            };
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace
            // data before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData, url);
            this.pushData(eventData);
            // console.log('trackHomePageview', eventData);
          }
          return this;
        },

        trackPageviewForCart: function (data) {
          if (_.isString(data.url)) {
            var eventName = 'cartView';
            var eventData1 = {
              event: eventName,
              data: {
                page: data.url,
                currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                total: data.total || '',
                items: []
              }
            };
            if (data.items && data.items.length) {
              data.items.each(function (item) {
                eventData1.data.items.push({
                  sku: item.get('item').get('itemid'),
                  id: item.get('item').get('itemid'),
                  title: item.get('item').get('displayname'),
                  price: item.get('rate_formatted'),
                  quantity: item.get('quantity'),
                  image: item.get('item').get('itemimages_detail').urls && item.get('item').get('itemimages_detail').urls.length && item.get('item').get('itemimages_detail').urls[0].url || ''
                });
              });
            }
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace data
            // before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData1, data.url);
            this.pushData(eventData1);
            // console.log('trackPageviewForCart', eventData1);
          }
          return this;
        },

        trackPageviewForCheckoutStep: function (step) {
          var eventName = 'checkoutView';
          var eventData = {
            event: eventName,
            ecommerce: {
              checkout: {
                actionField: { step: step }
              }
            }
          };
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data
          // before is send it to Google Tag Manager
          Tracker.trigger(eventName, eventData);
          this.pushData(eventData);
          // console.log('trackPageviewForCheckoutStep', eventData);
          return this;
        },

        trackNonEcomemercePageView: function (url) {
          if (_.isString(url)) {
            var eventName = 'nonEcommercePageView';
            var eventData = {
              event: eventName,
              data: {
                page: url
              }
            };
              // Triggers a Backbone.Event so others can subscribe to this event and add/replace data
              // before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData, url);
            this.pushData(eventData);
          }
          console.log('trackNonEcomemercePageView', eventData);
          return this;
        },

        trackEvent: function (event) {
          if (event && event.category && event.action) {
            var eventName = event.name || 'action';
            var eventData = {
              event: eventName,
              data: {
                category: event.category,
                action: event.action,
                label: event.page || '/' + Backbone.history.fragment,
                value: event.value || ''
              },
              eventCallback: event.callback
            };
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace data
            // before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData, event);
            this.pushData(eventData);
            // console.log('trackEvent', eventData);
          }
          return this;
        },

        trackProceedToCheckout: function (callback) {
          var event = {
            name: 'proceedToCheckout',
            category: 'Checkout - User Interaction',
            action: 'Proceed To Checkout',
            callback: callback
          };
          // console.log('trackProceedToCheckout', event);
          this.trackEvent(event);
        },

        trackLogin: function (event) {
          var eventData = {
            name: 'login',
            category: event.category,
            action: event.action,
            callback: event.callback
          };
          // console.log('trackLogin', eventData);
          this.trackEvent(eventData);
        },

        trackCheckoutAsGuest: function (event) {
          var eventData = {
            name: 'checkoutAsGuest',
            category: event.category,
            action: event.action,
            callback: event.callback
          };
          // console.log('trackCheckoutAsGuest', eventData);
          this.trackEvent(eventData);
        },

        trackSelectedPayment: function (payment) {
          var event = {
            name: 'selectPayment',
            category: 'Checkout - User Interaction',
            action: 'Select Payment Method',
            value: payment
          };
          // console.log('trackSelectedPayment', event);
          this.trackEvent(event);
        },

        trackRegister: function (event) {
          var eventData = {
            name: 'register',
            category: event.category,
            action: event.action,
            callback: event.callback
          };
          // console.log('trackRegister', eventData);
          this.trackEvent(eventData);
        },

        trackAddToCart: function (line) {
          if (line) {
            var selectedOptions = line.get('options').filter(function (option) {
              return option.get('value') && option.get('value').label;
            });
            var item = line.get('item');
            var eventName = 'addToCart';
            var eventData = {
              event: eventName,
              ecommerce: {
                currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                add: {
                  products: [
                    {
                      sku: item.get('itemid'),
                      id: item.get('itemid'),
                      name: item.get('_name'),
                      price: item.get('_priceDetails').onlinecustomerprice,
                      variant: _.map(selectedOptions, function (option) {
                        return option.get('value').label;
                      }).join(', '),
                      category: this.getCategory(),
                      quantity: line.get('quantity')
                    }
                  ]
                }
              }
            };
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace
            // data before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData, line);
            // console.log('trackAddToCart', eventData);
            this.pushData(eventData);
          }
          return this;
        },

        trackCartUpdate: function (items) {
          if (items.length) {
            var eventName = 'cartItemsUpdate';
            var eventData2 = {
              event: eventName,
              data: {
                items: []
              }
            };
            items.each(function (line) {
              var item = line.get('item');
              eventData2.data.items.push({
                name: item.get('_name'),
                sku: item.get('itemid'),
                id: item.get('itemid'),
                price: line.get('rate'),
                amount: line.get('amount'),
                variant: _.map(line.get('options').toJSON(), function (option) {
                  return Boolean(option.value) && option.value.label;
                }).join(', '),
                quantity: line.get('quantity')
              });
            });
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace
            // data before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData2, items);
            // console.log('trackCartUpdate', eventData2);
            this.pushData(eventData2);
          }
          return this;
        },

        trackAddToWishlist: function (line) {
          if (line) {
            var item = line.get('item');
            var eventName = 'addToWishlist';
            var eventData = {
              event: eventName,
              data: {
                action: 'Add To Wishlist',
                currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                sku: item.get('itemid'),
                id: item.get('itemid'),
                name: item.get('_name'),
                price: item.get('_priceDetails').onlinecustomerprice,
                category: 'Shopping - User Interaction',
                // eslint-disable-next-line
                item_category: this.getCategory()
              }
            };
            // Triggers a Backbone.Event so others can subscribe to this event and add/replace
            // data before is send it to Google Tag Manager
            Tracker.trigger(eventName, eventData, line);
            // console.log('trackAddToWishlist', eventData);
            this.pushData(eventData);
          }
          return this;
        },

        trackTransaction: function (transaction) {
          var self = this;
          var eventName = 'transaction';
          var eventData = {
            event: eventName,
            ecommerce: {
              purchase: {
                actionField: {
                  id: transaction.get('confirmationNumber'),
                  affiliation: '',
                  revenue: transaction.get('subTotal') + transaction.get('taxTotal') + transaction.get('shippingCost') + transaction.get('handlingCost'),
                  currency: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                  subtotal: transaction.get('subTotal'),
                  tax: transaction.get('taxTotal'),
                  shipping: transaction.get('shippingCost') + transaction.get('handlingCost'),
                  coupon: []
                },
                products: []
              }
            }
          };
          _.each(transaction.get('promocodes'), function (promo) {
            eventData.ecommerce.purchase.actionField.coupon.push(promo.code);
          });
          transaction.get('products').each(function (product) {
            var result = self.findCategoryAndListInDataLayer(product);
            eventData.ecommerce.purchase.products.push({
              name: product.get('name'),
              sku: product.get('id'),
              id: product.get('id'),
              price: product.get('rate'),
              category: result ? result.category || '' : '',
              variant: product.get('options'),
              quantity: product.get('quantity')
            });
          });
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
          Tracker.trigger(eventName, eventData, transaction);
          this.pushData(eventData);
          // console.log('trackTransaction', eventData);
          return this;
        },

        trackProductListGeneric: function (eventName, items, listName) {
          if (this.trackingProductList) {
            this.resetTracker();
          }
          this.trackingProductList = true;
          var self = this;
          var eventData = {
            event: eventName,
            ecommerce: {
              currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
              impressions: []
            },
            page: this.getCategory(),
            list: listName,
            label: listName
          };
          _.each(items.models, function (item, index) {
            // We set this properties in the item so we can print them on the html, to later be read them by the trackProductClick event
            item.set('track_productlist_position', index + 1);
            item.set('track_productlist_category', self.getCategory());
            item.set('track_productlist_list', listName);
            eventData.ecommerce.impressions.push({
              name: item.get('_name'),
              sku: item.get('_sku', true),
              id: item.get('_sku', true),
              price: item.get('_price') && item.get('_price').toFixed(2) || 0.0,
              list: item.get('track_productlist_list'),
              position: item.get('track_productlist_position'),
              category: item.get('track_productlist_category')
            });
          });
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
          Tracker.trigger(eventName, eventData, items);
          this.pushData(eventData);
          // console.log('trackProductListGeneric', eventData);
          this.resetTracker();
          this.trackingProductList = false;
          return this;
        },

        trackSearchResults: function (items, keyword) {
          var self = this;
          var eventData = {
            event: 'searchResults',
            data: {
              currencyCode: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
              page: this.getCategory(),
              list: 'searchResults',
              label: 'searchResults',
              items: [],
              keywords: keyword
            }
          };
          _.each(items.models, function (item, index) {
            eventData.data.items.push({
              name: item.get('_name'),
              sku: item.get('_sku', true),
              id: item.get('_sku', true),
              price: item.get('_price') && item.get('_price').toFixed(2) || 0.0,
              list: 'searchResults',
              position: index + 1,
              category: self.getCategory()
            });
          });
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
          Tracker.trigger('searchResults', eventData, items);
          this.pushData(eventData);
          // console.log('trackSearchResults', eventData);
          return this;
        },

        trackProductClick: function (item) {
          var eventName = 'productClick';
          var eventData = {
            event: eventName,
            ecommerce: {
              click: {
                actionField: { list: item.get('list') },
                products: [
                  {
                    name: item.get('name'),
                    price: item.get('price'),
                    sku: item.get('sku', true),
                    id: item.get('sku', true),
                    category: item.get('category'),
                    position: item.get('position')
                  }
                ]
              }
            }
          };
          // We set this item in this Tracker to later be read it by the trackProductView event
          this.item = item;
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
          this.pushData(eventData);
          // console.log('trackProductClick', eventData);
          Tracker.trigger(eventName, eventData, item);
          return this;
        },

        trackProductView: function (product) {
          var item = product.getItem();
          if (this.item && this.item.get('itemId') === item.get('_id')) {
            item.set('category', this.item.get('category'), { silent: true });
            item.set('list', this.item.get('list'), { silent: true });
          }
          var eventName = 'productView';
          var selectedOptions = product.get('options').filter(function (option) {
            return option.get('value') && option.get('value').label;
          });
          var price = product.getPrice();
          var result = this.findCategoryAndListInDataLayer(product);
          var eventData = {
            event: eventName,
            ecommerce: {
              detail: {
                actionField: {
                  list: item.get('list') || (result ? result.list : '')
                },
                products: [
                  {
                    name: item.get('_name'),
                    sku: product.getSku(),
                    id: product.getSku(),
                    category: item.get('category') || (result ? result.category : ''),
                    variant: _.map(selectedOptions, function (option) {
                      return option.get('value').label;
                    }).join(', '),
                    price: (price.price ? price.price : 0).toFixed(2)
                  }
                ]
              }
            },
            page: this.getCategory()
          };
          this.item = null;
          // Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
          Tracker.trigger(eventName, eventData, item);
          // console.log('trackProductView', eventData);
          this.pushData(eventData);
          return this;
        }


        // GoogleTagManager.trackPageview = _.wrap(GoogleTagManager.trackPageview, function wrap(fn) {
        // 	var origReturn = fn.apply(this, Array.prototype.slice.call(arguments, 1));
        //   console.log('custom this', this);
        //   console.log('custom track pages', origReturn);
        // 	return origReturn;
        // });
      });
    }

  };
});
